<template>
    <div class="" style="margin-left: 75px">
        <!-- site dialog -->
        <d-site
            v-model  = "showSite"
            :site-id = "siteId"
            :edit    = "editUnit"
            @saved   = "onUnitSaved"
        />
        <!-- site dialog -->

        <!-- customer preferences dialog -->
        <d-customer
            v-model   = "showTemplates"
            :customer = "customer.selected"
            :key      = "customer.selected ? customer.selected.id : 0"
        />
        <!-- template dialog -->

        <!-- recipients edit -->
        <recipients-edit
            v-model  = "recipients.edit"
            :company = "recipients.selected"
        />
        <!-- recipients edit -->

        <d-operator-dialog
            v-model   = "operator.edit"
            :customer = "customer.selected"
            @refresh  = "onRefreshOperator"
        />

        <d-customer-responsibilities
            v-model   = "showResponsibilities"
            :customer = "customer.selected"
        />

        <d-customer-bulk-update
            v-model = "bulkUpdate.show"
            :units  = "bulkUpdate.units"
            @done   = "onBulkUpdateDone"
        />

       <company-app-bar
            title="KUNDEN"
            :categories = "['customer']"
            @search     = "onSearch"
        >
           <template v-slot:toolbar>
               <c-toolbar-button
                   icon     = "mdi-database-import"
                   color    = "primary"
                   :size    = "22"
                   :tooltip = "$t('home.button')"
                   class    = "ml-2"
                   @click   = "onImport"
               />
           </template>
       </company-app-bar>

         <c-customer-index
            :minimize      = "false"
            :enable-search = "false"
            :criterion     = "criterion"
            @changed       = "onCustomer"
            style          = "padding-right: 75px;"
        >
            <template v-slot:detail="{ item }">
                <div v-if="item" class="mt-1" style="width: calc(100% + 12px);">
                    <v-row class="no-frame">
                        <!-- companies -->
                        <v-col
                            class  = "no-frame ml-0 pl-3"
                            :class = "item.show ? 'pl-4' : 'pl-0'"
                            style  = "margin-top: 9px; padding-right: 10px!important;"
                        >
                            <company-edit
                                :company      = "customer.selected"
                                :height       = "410"
                                :comment-rows = "8"
                                :show-web     = "false"
                                style         = "margin-top: 9px;"
                            >
                                <template v-slot:toolbar>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="pr-1">
                                                <a
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click.stop="onTemplate"
                                                >
                                                    <v-icon size="17" class="pr-1 white--text">mdi-wrench</v-icon>
                                                </a>
                                            </div>
                                        </template>
                                        <span>Einstellungen bearbeiten</span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:additional>
                                    <v-autocomplete
                                        dense
                                        chips
                                        :label="$t('msd.customer.responsibles.title')"
                                        multiple
                                        auto-select-first
                                        deletable-chips
                                        hide-no-data
                                        return-object
                                        v-model       = "customer.selected.responsibles"
                                        :items        = "users"
                                        :menu-props   = "menuProps"
                                        item-value    = "id"
                                        item-text     = "name"
                                        autocomplete  = "off"
                                        autocorrect   = "off"
                                        autocapitalize= "off"
                                        spellcheck    = "false"
                                        class         = "mt-4"
                                        append-icon   = ""
                                    >
                                        <template v-slot:item="data">
                                            <v-list-item-content>
                                                <v-list-item-title class="component-title" v-html="data.item.name" />
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-if="data.index < 2"
                                                color        = "primary"
                                                style        = "margin: 1px"
                                                close-icon   = "mdi-close"
                                                @click:close = "onRemoveResponsible(data.item)"
                                                close
                                            >
                                                <div class="pl-1">
                                                    <div class="selected-responsible">
                                                        {{ data.item.name }}
                                                    </div>
                                                    <div class="selected-responsible-email">
                                                        {{ data.item.email }}
                                                    </div>
                                                </div>
                                            </v-chip>
                                            <span
                                                v-if="data.index === 2 && customer.selected.responsibles.length > 2"
                                                class="items-others"
                                            >(+ {{ customer.selected.responsibles.length - 2 }})</span>
                                        </template>
                                    </v-autocomplete>

                                    <div v-if="customer.selected.responsibles.length <= 1" style="height: 70px;">

                                    </div>

                                    <div v-if="customer.selected.responsibles.length > 1" class="v-flex">
                                        <div :style="isResponsibilityRefinement ? 'width: calc(100% - 30px)' : 'width: 100%'">
                                            <f-enum-select
                                                v-model   = "customer.selected.responsibilityType"
                                                label     = "Verantwortliche Liftmanager Zuordnung über ..."
                                                module    = "msd"
                                                type      = "customerResponsibilityType"
                                            />
                                        </div>
                                        <div style="width: 30px; margin-top: 25px" v-if="isResponsibilityRefinement">
                                            <c-toolbar-button
                                                color   = "primary"
                                                size    = "28"
                                                icon    = "mdi-clipboard-account"
                                                tooltip = "Liftmanager zuordnen"
                                                @click  = "onAssignLifties"
                                            />
                                        </div>
                                    </div>
                                </template>
                            </company-edit>

                            <c-flip-card
                                v-if    = "isCompanyAndRecipientsVisible"
                                v-model = "flip"
                                color   = "white--text" :top="17" :right="90"
                                class   = "mt-1"
                                style   = "width: calc(100% + 10px); height: calc(100% - 500px);"
                            >
                                <template v-slot:front>
                                    <c-card-iterator
                                        label          = "Betreiber"
                                        v-if           = "companies.items"
                                        :items         = "companies.items"
                                        :item-height   = "90"
                                        :filter-height = "79"
                                        :pagination-on = "true"
                                        :total-visible = "5"
                                        :min-height    = "553"
                                        class          = "w-100"
                                        :key           = "refreshOperator"
                                    >
                                        <template v-slot:toolbar>
                                            <div class="pl-1" style="margin-top: -2px">
                                                <c-toolbar-button
                                                    :size    = "24"
                                                    icon     = "mdi-plus"
                                                    color    = "white"
                                                    :tooltip = "$t('msd.operator.create')"
                                                    @click   = "onOperator"
                                                />
                                            </div>
                                        </template>
                                        <template v-slot:card="{ item }">
                                            <company-card
                                                style       = "width: calc(100% - 1px)"
                                                :company    = "item"
                                                :allow-edit = "true"
                                                @click      = "onOperatorSelect"
                                                @refresh    = "onRefreshOperator"
                                                :background = "operatorBackground (item)"
                                            />
                                        </template>
                                    </c-card-iterator>
                                </template>
                                <template v-slot:back>
                                    <c-recipient-card-iterator
                                        :customer-id = "customer.selected ? customer.selected.id : null"
                                        :top-space   = "553"
                                        @selected    = "onRecipient"
                                        class        = "w-100"
                                    />
                                </template>
                            </c-flip-card>

                        </v-col>
                        <!-- companies -->

                        <!-- contacts -->
                        <v-col class="no-frame pl-1 pr-0">
                            <c-flip-card
                                v-if    = "item.item"
                                v-model = "flip"
                                color   = "white--text"
                                :top    = "17"
                                :right  = "80"
                            >
                                <template v-slot:front>
                                    <c-contact-card-iterator
                                        :items       = "contacts.items"
                                        :contract-id = "contracts.selected ? contracts.selected.id : null"
                                        :company-id  = "operator.selected ? operator.selected.id : null"
                                        :customer-id = "customer.selected ? customer.selected.id : null"
                                        :combine-allowed = "true"
                                        mode         = "customer"
                                        @selected    = "onContact"
                                        class        = "w-100"
                                    />
                                </template>
                                <template v-slot:back>
                                    <c-contract-lim-card-iterator
                                        :contact-id   = "contacts.selected ? contacts.selected.id : null"
                                        :company-id   = "customer.selected ? customer.selected.id : null"
                                        :recipient-id = "recipients.selected ? recipients.selected.id : null"
                                        @selected     = "onContract"
                                        @renew        = "onRenew"
                                        class         = "w-100"
                                    />
                                </template>
                            </c-flip-card>
                        </v-col>
                        <!-- contacts -->

                        <v-col class="no-frame pl-1">
                            <c-site-card-iterator
                                v-if             = "item.item"
                                class            = "w-100"
                                role             = "CUSTOMER"
                                :customer        = "item.item"
                                :contract        = "contracts.selected"
                                :contact         = "contacts.selected"
                                :contract-height = "contractHeight"
                                :allow-new       = "isUnitAdmin"
                                :allow-bulk-edit = "false"
                                @site            = "onSite"
                                @new-site        = "onNewSite"
                                @bulk-edit       = "onBulkUpdate"
                                ref              = "siteIterator"
                            >
                                <template v-slot:editor="{ site }">
                                    <c-contract-lim-editor
                                        v-if  = "isLim"
                                        :unit = "site"
                                    />
                                    <c-contract-dls-editor
                                        v-if  = "isDls"
                                        :unit = "site"
                                    />
                                </template>
                            </c-site-card-iterator>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </c-customer-index>
    </div>
</template>

<script>

import Core                     from "@/modules/core/service/Core";
import Company                  from "@/modules/msd/company/common/service/Company";
import Contact                  from "@/modules/msd/company/contact/service/Contact";
import Customer                 from "@/modules/msd/company/customer/service/Customer";
import CSiteCardIterator        from "@/modules/msd/unit/components/controlls/CSiteCardIterator";
import CCardIterator            from "@/modules/core/components/utils/CCardIterator";
import CompanyCard              from "@/modules/msd/company/common/components/controlls/CompanyCard";
import CompanyEdit              from "@/modules/msd/company/common/components/controlls/CompanyEdit";
import CFlipCard                from "@/modules/core/components/utils/CFlipCard";
import CCustomerIndex           from "@/modules/msd/company/customer/components/controlls/CCustomerIndex";
import RecipientsEdit           from "@/modules/msd/company/recipient/components/DRecipientsEdit";
import CRecipientCardIterator   from "@/modules/msd/company/recipient/components/CRecipientCardIterator";
import DSite                    from "@/modules/msd/unit/components/dialog/DSite";
import DCustomer                from "@/modules/msd/company/customer/components/main/DCustomer";
import CContactCardIterator     from "@/modules/msd/company/contact/components/controlls/CContactCardIterator";
import CContractLimCardIterator from "@/modules/msd/company/contract/components/controls/lim/CContractLimCardIterator";
import CompanyAppBar            from "@/modules/msd/company/common/components/nav/CompanyAppBar";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import DOperatorDialog from "@/modules/msd/company/operator/DOperatorDialog.vue";
import CContractLimEditor from "@/modules/msd/company/contract/components/controls/lim/CContractLimEditor.vue";
import CContractDlsEditor from "@/modules/msd/company/contract/components/controls/lim/CContractDlsEditor.vue";
import Contract from "@/modules/msd/company/contract/service/Contract";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect.vue";
import DCustomerResponsibilities from "@/modules/msd/company/customer/components/controlls/DCustomerResponsibilities.vue";
import DCustomerBulkUpdate from "@/modules/msd/company/customer/components/controlls/DCustomerBulkUpdate.vue";

export default {
    name: "MCustomer",

    components: {
        DCustomerBulkUpdate,
        DCustomerResponsibilities,
        FEnumSelect,
        CContractDlsEditor,
        CContractLimEditor,
        DOperatorDialog,
        CToolbarButton,
        CompanyAppBar,
        CContractLimCardIterator,
        CContactCardIterator,
        DSite,
        CRecipientCardIterator,
        RecipientsEdit,
        CCustomerIndex,
        CFlipCard,
        CompanyEdit,
        CompanyCard,
        CCardIterator,
        CSiteCardIterator,
        DCustomer
    },

    data: () => ({
        criterion : "",
        showSite  : false,
        showTemplates: false,
        showResponsibilities: false,
        bulkUpdate: {
            show: false,
            units: null,
        },
        siteId    : null,
        editUnit  : false,
        background: null,
        flip: true,
        contractHeight: 0,
        refreshOperator: 0,
        menuProps: {
            closeOnClick: true,
        },
        customer: {
            selected: null,
            filterOn: false,
            lim     : false,
        },
        contracts: {
            selected: null,
            editselected: null,
            edit    : false,
        },
        companies: {
            items   : null,
            selected: null,
            edit    : false,
        },
        recipients: {
            selected: null,
            edit    : false,
       },
        contacts: {
            items   : null,
            selected: null,
            refresh : 0
        },
        operator: {
            edit: false,
            selected: null
        }
    }),

    watch: {
        recipientsEdit () {
            if (!this.recipients) {
                this.recipients.selected = null;
            }
        },

        contractEdit () {
            if (!this.contractEdit) {
                this.contracts.editselected = null;
            }
        },

        flip () {
            this.contracts.selected = null;
            this.contacts.selected  = null;
        }
    },

    computed: {
        contractEdit () {
            return this.contracts.edit;
        },

        isCompanyAndRecipientsVisible () {
            return this.customer.selected; // (this.companies.items && this.companies.items.length > 0) || (this.recipients.items && this.recipients.items.length > 0)
        },

        users () {
            return this.$store.getters.msd.users;
        },

        isLim () {
            return this.contracts.selected && this.contracts.selected.type.id === Contract.enums.types.lim;
        },

        isDls () {
            return this.contracts.selected && this.contracts.selected.type.id === Contract.enums.types.dls;
        },

        isResponsibilityRefinement () {
            if (!this.customer.selected || !this.customer.selected.responsibilityType) {
                return false;
            }

            return this.customer.selected.responsibilityType.id !== 0
        },

        isUnitAdmin () {
            return Core.security.isUnitAdmin();
        }
    },

    mounted() {
        Core.init.load(this.$store, false).then(() => {
        })
    },

    methods: {
        load() {
            this.loadCustomer();
            this.loadContacts();
            this.loadCompanies();
        },

        onSearch (criterion) {
            this.criterion = criterion;
        },

        onImport () {
            Core.nav.push(this, "limimport");
        },

        onUnitSaved (unit) {
            console.log("unit", unit)
            this.$refs.siteIterator.update (unit);
        },

         onCustomer(item) {
            if (!item) {
                this.customer.selected = null;
                this.contracts.items = null;
                this.contracts.selected = null;
                this.contacts.selected = null;
                this.contacts.items = null;
                this.companies.items = null;
                this.companies.selected = null;
                this.recipients.items = null;
                this.recipients.selected = null;
                this.operator.selected = null;
                this.$store.dispatch("setTitle", null);
                return;
            }

            this.$store.dispatch("setTitle", item.name);
            this.customer.selected = item;
            this.contracts.selected = null;
            this.contacts.selected = null;
            this.recipients.selected = null;
            this.operator.selected = null;

            this.load();
        },

        onContact(contact) {
            this.$refs.siteIterator.onEndAssingMode();
            this.contracts.selected = null;
            this.contacts.selected = contact;
        },

        onContract (contract) {
            this.$refs.siteIterator.onEndAssingMode();
            this.contacts.selected = null;
            this.contracts.selected = contract;
            if (this.isDls) {
                this.contractHeight = 112;
            }

            if (this.isLim) {
                this.contractHeight = 62;
            }
        },

        onRenew () {
            this.$refs.siteIterator.load();
        },

        onRecipient (recipient) {
            this.recipients.selected = recipient;
        },

        onEdit(contact) {
            this.contacts.editselected = contact;
            this.contacts.edit = true;
        },

        onCombine(contact) {
            this.contacts.selected = contact;
            this.contacts.combine = true;
        },

        onCombined() {
            this.load();
        },

        onSite (site) {
            this.editUnit = false;
            this.showSite = true;
            this.siteId = site.id;
        },

        onNewSite (site) {
            this.showSite = true;
            this.editUnit = true;
            this.siteId = site.id;
        },

        onBulkUpdate (units) {
            this.bulkUpdate.units = Core.data.clone(units);
            this.bulkUpdate.show = true;
        },

        onBulkUpdateDone () {
            this.$refs.siteIterator.load();
        },

        onTemplate () {
            this.showTemplates = true;
        },

        onRemoveResponsible (item) {
            const index = this.customer.selected.responsibles.findIndex(s => s.id === item.id);
            if (index >= 0) {
                this.customer.selected.responsibles.splice(index, 1)
            }
        },

        onOperator () {
            this.operator.edit = true;
        },

        onRefreshOperator () {
            this.loadCompanies();
        },

        onOperatorSelect (company) {
            this.contracts.selected = null;
            this.contacts.selected = null;
            this.recipients.selected = null;

            if (!this.operator.selected) {
                this.operator.selected = company;
            } else if (this.operator.selected.id === company.id) {
                this.operator.selected = null;
            } else {
                this.operator.selected = company;
            }
        },

        onAssignLifties () {
            this.showResponsibilities = true;
        },

        operatorBackground (company) {
            return this.operator.selected && this.operator.selected.id === company.id ? 'card-preselected' : '';
        },

        isSelected(customer, item) {
            return customer && customer.selected && customer.selected.id === item.id;
        },

        isLiftmanagement (item) {
            return Customer.isType(item, 1) || Customer.isType(item, 2);
        },

        isType(item, type) {
            return Customer.isType(item, type);
        },

        loadCustomer () {
            this.customer.lim = this.isLiftmanagement(this.customer.selected);
            Customer.byId(this.customer.selected.id, (data) => {
                this.customer.selected = data;
            });
        },

        loadCompanies () {
            Customer.companies(this.customer.selected.id, (data) => {
                this.companies.items = data;
            });
        },

        loadContacts () {
            Company.contacts(this.customer.selected.id, {}, (data) => {
                this.contacts.items = data;
            });
        },

        contactFilter (contact, text) {
            return Contact.filter(contact, text);
        },
    }
}
</script>


<style scoped>

.selected-responsible,
.selected-responsible-email{
    width: 120px;
    max-width: 120px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.selected-responsible {
    margin-top: -8px;
    font-size: 14px;
}

.selected-responsible-email {
    font-size: 10px;
    margin-top: -6px;
}

.items-others {
    font-size: 13px;
    padding-left: 5px;
    margin-top: -2px;
}

::v-deep .v-select__selections {
    margin-top: 0;
    margin-bottom: 4px;
}

::v-deep .theme--light.v-chip:not(.v-chip--active) {
    /*    background: #eceff1; */
}

::v-deep .v-select.v-select--chips .v-chip--select.v-chip--active::before {
    opacity: 0.12;
}

::v-deep .v-chip.v-size--default {
    height: 30px;
}

</style>